export enum Languages {
    EN = 'en',
    DE = 'de',
    ET = 'et',
    RU = 'ru',
    ES = 'es',
    PT = 'pt',
    PL = 'pl',
    FR = 'fr',
    IT = 'it',
    GR = 'el',
    CS = 'cs',
    NL = 'nl',
    FI = 'fi',
    DA = 'da',
    SK = 'sk',
    HU = 'hu',
    SV = 'sv',
    LV = 'lv',
    BG = 'bg',
    RO = 'ro',
    LT = 'lt',
    HE = 'he',
    HR = 'hr',
    JA = 'ja',
    ZH = 'zh',
    SR = 'sr',
    NO = 'no',
}
